'use client';

import { ComponentPropsWithRef } from 'react';
import { Icon } from '@/shared/ui/icon';
import './search-bar.scss';

const ID = 'search-bar-input';

type Props = ComponentPropsWithRef<'input'>;
export const SearchBar = ({ name, ref, ...props }: Props) => (
    <div className="search-bar" ref={ref}>
        <label htmlFor={name || ID}>
            <Icon name="search" />
        </label>
        <input type="text" data-testid={ID} id={name || ID} name={name} {...props} />
    </div>
);
SearchBar.displayName = 'SearchBar';
